import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" download: an arrow into a tray, drawn on a 24px grid.
export const Download = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-large", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.60059C12.3976 3.60059 12.72 3.92294 12.72 4.32059V12.8204L15.7572 9.78324C16.0383 9.50206 16.4942 9.50206 16.7754 9.78324C17.0566 10.0644 17.0566 10.5203 16.7754 10.8015L12.5398 15.0371C12.4079 15.1864 12.2149 15.2806 12 15.2806C11.7887 15.2806 11.5986 15.1896 11.4669 15.0446L7.22382 10.8015C6.94265 10.5203 6.94265 10.0644 7.22382 9.78324C7.505 9.50206 7.96088 9.50206 8.24206 9.78324L11.28 12.8212V4.32059C11.28 3.92294 11.6024 3.60059 12 3.60059ZM4.32 13.8394C4.71764 13.8394 5.04 14.1618 5.04 14.5594V17.9727C5.04 18.2344 5.14395 18.4854 5.32899 18.6704C5.51402 18.8555 5.76499 18.9594 6.02667 18.9594H17.9733C18.235 18.9594 18.486 18.8555 18.671 18.6704C18.856 18.4854 18.96 18.2344 18.96 17.9727V14.5594C18.96 14.1618 19.2824 13.8394 19.68 13.8394C20.0776 13.8394 20.4 14.1618 20.4 14.5594V17.9727C20.4 18.6163 20.1443 19.2336 19.6892 19.6887C19.2342 20.1437 18.6169 20.3994 17.9733 20.3994H6.02667C5.38307 20.3994 4.76584 20.1437 4.31075 19.6887C3.85567 19.2336 3.6 18.6163 3.6 17.9727V14.5594C3.6 14.1618 3.92235 13.8394 4.32 13.8394Z"
      fill="currentColor"
    />
  </svg>
);
